import { defineMessages } from 'react-intl';

export default defineMessages({
  list: {
    id: 'tnc.list',
    defaultMessage: 'Terms & Condition List',
  },
  detail: {
    id: 'tnc.detail',
    defaultMessage: 'Terms & Condition View',
  },
  update: {
    id: 'tnc.update',
    defaultMessage: 'Update Terms & Condition',
  },
  log: {
    id: 'tnc.log',
    defaultMessage: 'Version History Log',

    no: {
      id: 'tnc.log.no',
      defaultMessage: 'No',
    },
    version: {
      id: 'tnc.log.version',
      defaultMessage: 'Version',
    },
    created: {
      id: 'tnc.log.created',
      defaultMessage: 'Created At',
    },
  },
  data: {
    id: {
      id: 'tnc.detail.id',
      defaultMessage: 'TNC Id',
    },
    name: {
      id: 'tnc.detail.name',
      defaultMessage: 'File Name',
    },
    version: {
      id: 'tnc.detail.version',
      defaultMessage: 'Latest File Version',
    },
    preview: {
      id: 'tnc.detail.preview',
      defaultMessage: 'Terms & Condition Preview',
    },
  },
});
